import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToManageDifficultConversations');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS</div>
                                            <p>The best next step is to identify the most difficult
                                                conversations that you have coming up. Take a moment to think
                                                about whether the difficulty lies in the people involved or the
                                                topic of discussion, or a combination.</p>
                                            <p>Use the PAF technique for each conversation. Don’t expect the
                                                perfect outcome every time you have a difficult conversation,
                                                but do make time afterwards to review what did go well and how
                                                you might build on this the next time you face a similar
                                                conversation.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                        to be assertive</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToCommunicateEffectively')}>How
                                                        to communicate effectively</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToActivelyListen')}>How
                                                        to actively listen</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToManageYourImpact')}>How
                                                        to manage your impact</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToBuildAndMaintainTrust')}>How
                                                        to build and maintain trust</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToGiveFeedback')}>How
                                                        to give feedback</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToReframeProblems')}>How
                                                        to reframe problems</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMakeReasonedJudgements')}>How
                                                        to make reasoned judgements</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToChallengeOthersEffectively')}>How
                                                        to challenge others effectively.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title referencepad"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES</div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"> Asch, S. (1956).
                                                    Studies of independence and conformity: A minority of one
                                                    against a unanimous majority.<span className="subtiltereg"> Psychological Monographs, 70.</span>
                                                </p></li>
                                                <li><p className="further_info_content">Parkinson,
                                                    S., &amp; Baddeley, M. (2011).<span className="subtiltereg"> Group Decision-making: An Economic Analysis of Social Influence and Individual Difference in Experimental Juries, University of Cambridge.</span>
                                                </p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }